import { Box, Grid, Stack, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";

export default function GuideButton() {
  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Palette</h2>
          </div>

          <h3 className="guide-h3">Color Swatches</h3>
          <div className="guide-cont">
            <Grid container spacing={1} className="guide-color">
              <Grid item>
                <div className="item">
                  <Chip label="Primary" color="primary" />
                  <p className="value">#F1270B</p>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <Chip
                    label="Text Default"
                    style={{ backgroundColor: "#000" }}
                  />
                  <p className="value">#F1270B</p>
                </div>
              </Grid>
            </Grid>
            <br />
            <h4 className="guide-h4">Grayscale</h4>
            <Grid container spacing={1} className="guide-color">
              <Grid item>
                <div className="item">
                  <Chip style={{ backgroundColor: "#8E8E8E" }} />
                  <p className="value">#8E8E8E</p>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <Chip style={{ backgroundColor: "#ccc" }} />
                  <p className="value">#cccccc</p>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <Chip style={{ backgroundColor: "#dfdfdf" }} />
                  <p className="value">#dfdfdf</p>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <Chip style={{ backgroundColor: "#eee" }} />
                  <p className="value">#eeeeee</p>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <Chip style={{ backgroundColor: "#f6f6f6" }} />
                  <p className="value">#f6f6f6</p>
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </main>
    </>
  );
}
